import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { logger } from '../utils/logger.util';


export interface WordViewerOpenOptions {
  title: string;
  /** URL déjà résolue — prioritaire sur s3Key. */
  wordUrl?: string;
  s3Key?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WordViewerService {
  private readonly requestSubject = new BehaviorSubject<WordViewerOpenOptions | null>(null);

  readonly request$ = this.requestSubject.asObservable();

  open(options: WordViewerOpenOptions): void {
    if (!options.wordUrl && !options.s3Key) {
      logger.warn('[WordViewerService] open() requiert wordUrl ou s3Key');
      return;
    }
    this.requestSubject.next(options);
  }

  close(): void {
    this.requestSubject.next(null);
  }
}
